module.exports = __webpack_public_path__ + "img/logo.1c800f35.svg";